/* Fashion CITY — 커스텀 토트백 스타일/색상 사진
     Large (1-MM9001) — Classic Canvas Tote   · 14.6 W x 19.7 H x 5.5 D (inch)
     Small (1-MM9002) — Essential Canvas Tote · 10.6 W x 13.8 H x 4.3 D (inch)
   두 가지 다 내추럴 한 색뿐이라 색 줄에는 사진이 하나씩만 뜹니다.
   ★ 사진은 홀세일 상품 이미지를 그대로 가리킵니다.
   ★ 스타일 이름에 실제 치수를 같이 적어 뒀습니다. 손님 화면에도 그대로 뜨고
     주문서 'Tote style' 줄에도 SKU 와 함께 그대로 찍힙니다.
   ※ 이 파일은 fc-po-colors.js 다음에 실행됩니다.
*/
window.FCPO_STYLES = window.FCPO_STYLES || {};
window.FCPO_PLACE_BY_HANDLE = window.FCPO_PLACE_BY_HANDLE || {};
(function () {
  var HANDLE = 'custom-cotton-tote-bag-your-design';
  var F = 'https://cdn.shopify.com/s/files/1/0372/5544/6665/files/';

  /* 인쇄/자수 자리 — 가방마다 사진 프레임이 달라서 따로 잡습니다.
     x, y : 사진 왼쪽 위가 0,0 / 오른쪽 아래가 100,100 (y 가 클수록 아래)
     w    : Medium 일 때 폭 (사진 가로폭의 %)
  */
  var PL9001 = { v: 'Front', x: 50, y: 63, w: 34, sizes: [5, 8, 10] };
  var PL9002 = { v: 'Front', x: 52, y: 58, w: 36, sizes: [5, 8, 10] };

  window.FCPO_STYLES[HANDLE] = {
    styleLabel: 'Tote size',
    colorLabel: 'Color',
    propStyle: 'Tote style',
    propColor: 'Color',
    styles: [
      {
        n: 'Large — 14.6 x 19.7 x 5.5 in',
        sku: '1-MM9001',
        colors: [['Natural', F + '1-MM9001.jpg']],
        place: PL9001
      },
      {
        n: 'Small — 10.6 x 13.8 x 4.3 in',
        sku: '1-MM9002',
        colors: [['Natural', F + '1-MM9002-BEIGE.jpg']],
        place: PL9002
      }
    ]
  };

  /* 앞면만 받습니다 (뒷면 사진이 없어서) */
  window.FCPO_PLACE_BY_HANDLE[HANDLE] = [PL9001];
})();